import { Field } from '@yes.technology/react-toolkit'
import { useMemo } from 'react'
import isUniselectionMultiplicity from '../lib/isUniselectionMultiplicity'

type UseRelationSelectionTypeProps = {
  relationFields?: Field[]
  columnName: string
  fallbackObjectclassUuid?: string
}

const useRelationSelectionType = ({
  relationFields,
  columnName,
  fallbackObjectclassUuid = ''
}: UseRelationSelectionTypeProps) => {
  return useMemo(() => {
    const relationField = relationFields?.find(
      (field) => field.column_json === columnName
    )

    const relation = relationField?.relation
    const multiplicity = relation?.multiplicity
    const objectclassUuid =
      relation?.uuid_objectclass || fallbackObjectclassUuid

    return {
      relationField,
      relation,
      objectclassUuid,
      isUniselection: isUniselectionMultiplicity(multiplicity)
    }
  }, [relationFields, columnName, fallbackObjectclassUuid])
}

export default useRelationSelectionType
